/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-box[_ngcontent-%COMP%]{--background:#fff}.card-box[_ngcontent-%COMP%]   .btn-ok[_ngcontent-%COMP%]{padding:var(--main-padding-sm)}"];
export { styles as styles };
